import React from "react";
import Navbar from "../wm_navigation/Navbar";
import BottomNav from "../wm_navigation/BottomNav";
import "./styles/home.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { loadUser } from "../wm_actions/auth";
import { GetNotification } from "../wm_actions/Notification";
// import { loadUsers, updateSentRequest } from '../wm_actions/connects';
import { Redirect } from "react-router-dom";
import Posts from "../wm_posts/posts";

class Home extends React.Component {
	state = {
		profession: this.props.profession
	};
	async componentWillMount() {
		await this.props.loadUser();
		await this.props.GetNotification();
		console.log(this.props.profession.length);
	}
	static propTypes = {
		users: PropTypes.string,
		profession: PropTypes.array,
		genre: PropTypes.array
	};

	render() {
		// if (
		// 	JSON.parse(localStorage.getItem("Profession"))?.length >= 0 &&
		// 	JSON.parse(localStorage.getItem("Profession"))?.length < 2
		// ) {
		// 	return <Redirect to="/completeProfile" />;
		// }
		return (
			<div id="homeWrapper">
				<Navbar />
				<Posts />
				<BottomNav />
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	profession: state.auth.profession
});
export default connect(mapStateToProps, { loadUser, GetNotification })(Home);
